import React, { useEffect, useState } from 'react'
import { Input, Button, Layout, Typography, Alert, Result, Space, Divider, Flex } from 'antd'
import api from '../service/axios'
import { useToasts } from 'react-toast-notifications';
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';



const { Content } = Layout

export const ConsultaARTCtrl = (props) => {

    const [searchParams] = useSearchParams();
    const navigate = useNavigate()
    const [ano, setAno] = useState(dayjs().format('YYYY'))
    const [numero, setNumero] = useState('')
    const [crq, setCrq] = useState('')
    const [loading, setLoading] = useState(false)
    const { addToast } = useToasts()
    const [data, setData] = useState(undefined)
    const [code, setCode] = useState(props.code)


    useEffect(() => {
        const _code = searchParams.get('code');
        if (_code) {
            setCode(_code)
            consulta(_code)
        }
    }, [])

    async function consulta(valor) {
        try {

            if (!valor) {
                setData(undefined)
                addToast("Informe o código de validação!", { appearance: 'error', autoDismiss: true });
                return
            }

            setLoading(true)
            const result = await api.post('api/v1.0/art/validar', { code: valor })
         //   console.log(result.data)
            setData(result.data)
            if (result.data.length === 0) {
                addToast("Não foi localizado nenhum registro!", { appearance: 'error', autoDismiss: true });
            }
        } catch (erro) {
            addToast(erro.message, { appearance: 'error', autoDismiss: true });
        }
        setLoading(false)
    }


    function renderConsultar() {
        return <React.Fragment>
            <Typography.Title level={3}>Consulta de ART</Typography.Title>
            <br />
            {/* <Flex>A consulta é feita para ART`s dentro do período de validade.</Flex> */}
            <br />
            {
                /*
  <Flex vertical gap={5}>
                <Input placeholder='Número' style={{ textAlign: 'center' }}
                    value={numero}
                    onChange={event => {
                        setNumero(event.target.value)
                    }} />

                <Input placeholder='Ano' style={{ textAlign: 'center' }}
                    value={ano}
                    onChange={event => {
                        setAno(event.target.value)
                    }} />
            </Flex>

            <Input placeholder='Nº do CRQ do profissional' style={{ textAlign: 'center', marginTop: 10 }}
                value={crq}
                onChange={event => {
                    setCrq(event.target.value)
                }} />
                */
            }

            <Flex>Código de Validação</Flex>
            <Input style={{ minWidth: 350, textAlign:'center' }} value={code} onChange={(e) => {
                setCode(e.target.value)
            }} />


            <Button type="primary" style={{ marginTop: 15 }} loading={loading} block onClick={() => consulta(code)}>
                Consultar
            </Button>

            {
                data?.length === 0 && <Alert style={{ marginTop: 15 }} message="Não foi localizado nenhum registro para os dados informados." type="error" />
            }
        </React.Fragment>
    }


    function renderResultado() {
        return <React.Fragment>
            <Result
                status="success"
                title={<span>DADOS DA ART </span>}
                subTitle={""}
                extra={[
                    <Alert type='info' description={
                        <Space direction='vertical'>
                            <Space direction={'horizontal'}>
                                Nº :
                                <strong> {data[0].numero} </strong>
                                <span style={{ marginLeft: 5 }}>ANO: </span>
                                <strong> {data[0].ano} </strong>
                            </Space>
                            <Flex justify='center' gap={5}>Profissional: <b> {data[0].nome}</b></Flex>
                            <Flex justify='center' gap={5}>CRQ: <b> {data[0].crqp}</b></Flex>
                            <Space direction={'horizontal'}>
                                Validade até:
                                <strong> {data[0].data} </strong>
                            </Space>
                            {
                                !data[0].cnpj.includes("_") && <Space direction={'horizontal'}>
                                    Solicitante:
                                    <strong> {data[0].cnpj} </strong>
                                </Space>
                            }
                            <Divider style={{ marginBottom: 5, marginTop: 5 }} />
                            <Space>
                                {data[0].tipo}
                            </Space>
                            <Divider style={{ marginBottom: 5, marginTop: 5 }} />
                            {
                                data[0].baixada === 1 && <Space direction={'horizontal'}>
                                    <span style={{ color: 'red' }}> ART BAIXADA </span>
                                </Space>
                            }
                        </Space>
                    }>

                    </Alert>,
                    <br />,
                    <Button key="buy" onClick={() => setData(undefined)}>Voltar</Button>
                ]}
            />
        </React.Fragment>
    }


    return (<Flex vertical gap={5}>
        <div
            style={{
                justifyContent: 'center',
                padding: 24,
                backgroundColor: 'white',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>

            <div style={{
                display: 'flex', justifyContent: 'center', flexDirection: 'column',
                maxWidth: 500, alignItems: 'center'
            }}>
                {data?.length > 0 ? renderResultado() : renderConsultar()}
            </div>

        </div>
    </Flex>


    )
}


export default ConsultaARTCtrl